module.exports = __webpack_public_path__ + "img/milestone-top.9af21ccd.png";